var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#013847"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6006 26.5624L41.6509 14.409L20.6006 26.5624ZM41.6509 14.409L24.5615 38.9471C24.4565 39.0738 24.3174 39.1678 24.1606 39.2178C24.0039 39.2678 23.836 39.2717 23.6771 39.2292C23.5181 39.1866 23.3748 39.0992 23.264 38.9775C23.1532 38.8559 23.0797 38.7049 23.0522 38.5427L20.6006 26.5624L11.4512 18.4492C11.3245 18.3443 11.2305 18.2051 11.1805 18.0484C11.1305 17.8916 11.1266 17.7238 11.1692 17.5648C11.2118 17.4059 11.2991 17.2625 11.4208 17.1517C11.5425 17.0409 11.6934 16.9674 11.8556 16.9399L41.6509 14.409Z",
    fill: "#5DB6CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6006 26.5624L41.6509 14.409M20.6006 26.5624L23.0522 38.5427C23.0797 38.7049 23.1532 38.8559 23.264 38.9775C23.3748 39.0992 23.5181 39.1866 23.6771 39.2292C23.836 39.2717 24.0039 39.2678 24.1606 39.2178C24.3174 39.1678 24.4565 39.0738 24.5615 38.9471L41.6509 14.409M20.6006 26.5624L11.4512 18.4492C11.3245 18.3443 11.2305 18.2051 11.1805 18.0484C11.1305 17.8916 11.1266 17.7238 11.1692 17.5648C11.2118 17.4059 11.2991 17.2625 11.4208 17.1517C11.5425 17.0409 11.6934 16.9674 11.8556 16.9399L41.6509 14.409",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.ec82415650cf43d09470230b64ef7762.svg";
export { ForwardRef as ReactComponent };